import config from '../../../../config'

import {
    PORTFOLIO_ACCESS_RIGHTS_REQUEST,
    PORTFOLIO_GET_GROUP_INFO_REQUEST,
    PORTFOLIO_GET_TOKEN_REQUEST,
    PORTFOLIO_GROUP_UPDATE,
    PORTFOLIO_GROUP_DELETE_UPDATE,
    OPEN_PORTFOLIO_BY_ID,
    CLOSE_PORTFOLIO_BY_ID,
    REFRESH_PORTFOLIO_BY_ID,
    SET_PORTFOLIO_MODULE_ACCESS_RIGHTS,
} from './constants'

const MODULE_KEY = config.modules.portfolio.key

export function openPortfolioById(id) {
    return {
        type: OPEN_PORTFOLIO_BY_ID,
        data: {
            id,
        },
    }
}

export function closePortfolioById(id, fromTab = false) {
    return {
        type: CLOSE_PORTFOLIO_BY_ID,
        data: {
            id,
            fromTab,
        },
    }
}

export function refreshPortfolioById(id, force = false) {
    return {
        type: REFRESH_PORTFOLIO_BY_ID,
        data: {
            id,
            force,
        },
    }
}

export function portfolioGetGroupInfoRequest(groupId) {
    return {
        type: PORTFOLIO_GET_GROUP_INFO_REQUEST(groupId),
        payload: {
            ...config.api.portfolioGetGroupInfo,
            qs: {
                groupId,
            },
        },
    }
}

export function portfolioGetTokenRequest(groupId) {
    return {
        type: PORTFOLIO_GET_TOKEN_REQUEST(groupId),
        payload: {
            ...config.api.portfolioGetToken,
            qs: {
                groupId,
                scope: MODULE_KEY,
            },
        },
    }
}

export function portfolioGroupUpdate(groupId, updates) {
    return {
        type: PORTFOLIO_GROUP_UPDATE(groupId),
        data: {
            groupId,
            updates,
        },
    }
}

export function portfolioGroupDeleteUpdate(groupId, deleteUpdates) {
    return {
        type: PORTFOLIO_GROUP_DELETE_UPDATE(groupId),
        data: {
            groupId,
            deleteUpdates,
        },
    }
}

export function portfolioAccessRightsRequest() {
    return {
        type: PORTFOLIO_ACCESS_RIGHTS_REQUEST,
        payload: {
            ...config.api.portfolioAccessRights,
        },
    }
}

export function setPortfolioModuleAccessRights(accessRights) {
    return {
        type: SET_PORTFOLIO_MODULE_ACCESS_RIGHTS,
        data: {
            accessRights,
        },
    }
}
